module.exports = __webpack_public_path__ + "static/media/enterprise-plan.531b7eea.png";